// extracted by mini-css-extract-plugin
module.exports = {"social-card-share":"socialCardShare_social-card-share__wtAcq","card-header":"socialCardShare_card-header__qZilp","card":"socialCardShare_card__Xtb2f"};